import { Component, input } from '@angular/core';

import { MDHeaderComponent } from '@melodic-ui/components';
import { BetaTagComponent } from '../beta-tag/beta-tag.component';

@Component({
	selector: 'lb-page-header',
	standalone: true,
	imports: [MDHeaderComponent, BetaTagComponent],
	templateUrl: './page-header.component.html',
	styleUrl: './page-header.component.scss'
})
export class PageHeaderComponent {
	public pageTitle = input.required<string>();
	public pageSubtitle = input<string>();
	public isBeta = input<boolean>(false);
}
